import Icon from '../../../components/AppIcon';

interface Statistic {
  icon: string;
  value: string;
  label: string;
}

const StatisticsBar = () => {
  const statistics: Statistic[] = [
    { icon: 'Users', value: '50+', label: 'Happy Clients' },
    { icon: 'Star', value: '4.9/5', label: 'Average Rating' },
    { icon: 'Award', value: '100%', label: 'Success Rate' },
    { icon: 'TrendingUp', value: '3x', label: 'Growth Impact' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
      {statistics.map((stat, index) => (
        <div
          key={index}
          className="glass-card rounded-xl p-6 text-center group"
        >
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-cta mb-4 group-hover:scale-110 transition-transform duration-300 shadow-brand">
            <Icon name={stat.icon} size={22} color="white" />
          </div>
          <div className="text-3xl font-bold text-white mb-1 glow-text">{stat.value}</div>
          <div className="text-sm text-white/55">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsBar;